import { type TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** ISO8601 Date values */
    Date: { input: string; output: string };
    GetPassengerMode: {
        input: GetPassengerModeEnum;
        output: GetPassengerModeEnum;
    };
    /** BigInt value */
    GraphQLBigInt: { input: string; output: string };
    /** A Float or a String */
    GraphQLStringOrFloat: { input: string | number; output: string | number };
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: { input: Record<string, string>; output: Record<string, string> };
    PassengerFieldsJSON: {
        input: PassengerFieldsEnum;
        output: PassengerFieldsEnum;
    };
    TicketingFaqJSON: { input: TicketingFaq; output: TicketingFaq };
    TicketingFormJSON: { input: TicketingForm; output: TicketingForm };
    TicketingFormNoteJSON: {
        input: TicketingFormNote;
        output: TicketingFormNote;
    };
    TicketingFormOptionJSON: {
        input: TicketingFormOption;
        output: TicketingFormOption;
    };
};

export type ClubBrands = {
    __typename?: 'ClubBrands';
    Icon?: Maybe<Directus_Files>;
    Title?: Maybe<Scalars['String']['output']>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type ClubBrandsIconArgs = {
    filter?: InputMaybe<Directus_Files_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClubBrands_Aggregated = {
    __typename?: 'ClubBrands_aggregated';
    avg?: Maybe<ClubBrands_Aggregated_Fields>;
    avgDistinct?: Maybe<ClubBrands_Aggregated_Fields>;
    count?: Maybe<ClubBrands_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<ClubBrands_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<ClubBrands_Aggregated_Fields>;
    min?: Maybe<ClubBrands_Aggregated_Fields>;
    sum?: Maybe<ClubBrands_Aggregated_Fields>;
    sumDistinct?: Maybe<ClubBrands_Aggregated_Fields>;
};

export type ClubBrands_Aggregated_Count = {
    __typename?: 'ClubBrands_aggregated_count';
    Icon?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type ClubBrands_Aggregated_Fields = {
    __typename?: 'ClubBrands_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ClubBrands_Filter = {
    Icon?: InputMaybe<Directus_Files_Filter>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<ClubBrands_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<ClubBrands_Filter>>>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type ClubBrands_Mutated = {
    __typename?: 'ClubBrands_mutated';
    data?: Maybe<ClubBrands>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type ClubCategories = {
    __typename?: 'ClubCategories';
    Icon?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    sort?: Maybe<Scalars['Int']['output']>;
};

export type ClubCategories_Aggregated = {
    __typename?: 'ClubCategories_aggregated';
    avg?: Maybe<ClubCategories_Aggregated_Fields>;
    avgDistinct?: Maybe<ClubCategories_Aggregated_Fields>;
    count?: Maybe<ClubCategories_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<ClubCategories_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<ClubCategories_Aggregated_Fields>;
    min?: Maybe<ClubCategories_Aggregated_Fields>;
    sum?: Maybe<ClubCategories_Aggregated_Fields>;
    sumDistinct?: Maybe<ClubCategories_Aggregated_Fields>;
};

export type ClubCategories_Aggregated_Count = {
    __typename?: 'ClubCategories_aggregated_count';
    Icon?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    sort?: Maybe<Scalars['Int']['output']>;
};

export type ClubCategories_Aggregated_Fields = {
    __typename?: 'ClubCategories_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
    sort?: Maybe<Scalars['Float']['output']>;
};

export type ClubCategories_Filter = {
    Icon?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<ClubCategories_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<ClubCategories_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
    sort?: InputMaybe<Number_Filter_Operators>;
};

export type ClubCategories_Mutated = {
    __typename?: 'ClubCategories_mutated';
    data?: Maybe<ClubCategories>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type ClubPrizez = {
    __typename?: 'ClubPrizez';
    BrandId?: Maybe<ClubBrands>;
    Category?: Maybe<ClubCategories>;
    Description?: Maybe<Scalars['String']['output']>;
    ExpireDate?: Maybe<Scalars['Date']['output']>;
    ExpireDate_func?: Maybe<Datetime_Functions>;
    HasDiscount?: Maybe<Scalars['Boolean']['output']>;
    Link?: Maybe<Scalars['String']['output']>;
    LinkTitle?: Maybe<Scalars['String']['output']>;
    Score?: Maybe<Scalars['Int']['output']>;
    ScoreDescription?: Maybe<Scalars['String']['output']>;
    UsedCount?: Maybe<Scalars['Int']['output']>;
    UserLevel?: Maybe<Scalars['String']['output']>;
    UserType?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type ClubPrizezBrandIdArgs = {
    filter?: InputMaybe<ClubBrands_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClubPrizezCategoryArgs = {
    filter?: InputMaybe<ClubCategories_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClubPrizez_Aggregated = {
    __typename?: 'ClubPrizez_aggregated';
    avg?: Maybe<ClubPrizez_Aggregated_Fields>;
    avgDistinct?: Maybe<ClubPrizez_Aggregated_Fields>;
    count?: Maybe<ClubPrizez_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<ClubPrizez_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<ClubPrizez_Aggregated_Fields>;
    min?: Maybe<ClubPrizez_Aggregated_Fields>;
    sum?: Maybe<ClubPrizez_Aggregated_Fields>;
    sumDistinct?: Maybe<ClubPrizez_Aggregated_Fields>;
};

export type ClubPrizez_Aggregated_Count = {
    __typename?: 'ClubPrizez_aggregated_count';
    BrandId?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Scalars['Int']['output']>;
    Description?: Maybe<Scalars['Int']['output']>;
    ExpireDate?: Maybe<Scalars['Int']['output']>;
    HasDiscount?: Maybe<Scalars['Int']['output']>;
    Link?: Maybe<Scalars['Int']['output']>;
    LinkTitle?: Maybe<Scalars['Int']['output']>;
    Score?: Maybe<Scalars['Int']['output']>;
    ScoreDescription?: Maybe<Scalars['Int']['output']>;
    UsedCount?: Maybe<Scalars['Int']['output']>;
    UserLevel?: Maybe<Scalars['Int']['output']>;
    UserType?: Maybe<Scalars['Int']['output']>;
    date_created?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_created?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type ClubPrizez_Aggregated_Fields = {
    __typename?: 'ClubPrizez_aggregated_fields';
    BrandId?: Maybe<Scalars['Float']['output']>;
    Category?: Maybe<Scalars['Float']['output']>;
    Score?: Maybe<Scalars['Float']['output']>;
    UsedCount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type ClubPrizez_Filter = {
    BrandId?: InputMaybe<ClubBrands_Filter>;
    Category?: InputMaybe<ClubCategories_Filter>;
    Description?: InputMaybe<String_Filter_Operators>;
    ExpireDate?: InputMaybe<Date_Filter_Operators>;
    ExpireDate_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    HasDiscount?: InputMaybe<Boolean_Filter_Operators>;
    Link?: InputMaybe<String_Filter_Operators>;
    LinkTitle?: InputMaybe<String_Filter_Operators>;
    Score?: InputMaybe<Number_Filter_Operators>;
    ScoreDescription?: InputMaybe<String_Filter_Operators>;
    UsedCount?: InputMaybe<Number_Filter_Operators>;
    UserLevel?: InputMaybe<String_Filter_Operators>;
    UserType?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<ClubPrizez_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<ClubPrizez_Filter>>>;
    date_created?: InputMaybe<Date_Filter_Operators>;
    date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_created?: InputMaybe<String_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type ClubPrizez_Mutated = {
    __typename?: 'ClubPrizez_mutated';
    data?: Maybe<ClubPrizez>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export enum EventEnum {
    Create = 'create',
    Delete = 'delete',
    Update = 'update',
}

export enum GetPassengerModeEnum {
    None = 'None',
    Optional = 'Optional',
    Required = 'Required',
}

export type MagBestContent = {
    __typename?: 'MagBestContent';
    Content?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<Directus_Files>;
    Link?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type MagBestContentImageArgs = {
    filter?: InputMaybe<Directus_Files_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MagBestContent_Aggregated = {
    __typename?: 'MagBestContent_aggregated';
    avg?: Maybe<MagBestContent_Aggregated_Fields>;
    avgDistinct?: Maybe<MagBestContent_Aggregated_Fields>;
    count?: Maybe<MagBestContent_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<MagBestContent_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<MagBestContent_Aggregated_Fields>;
    min?: Maybe<MagBestContent_Aggregated_Fields>;
    sum?: Maybe<MagBestContent_Aggregated_Fields>;
    sumDistinct?: Maybe<MagBestContent_Aggregated_Fields>;
};

export type MagBestContent_Aggregated_Count = {
    __typename?: 'MagBestContent_aggregated_count';
    Content?: Maybe<Scalars['Int']['output']>;
    Image?: Maybe<Scalars['Int']['output']>;
    Link?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type MagBestContent_Aggregated_Fields = {
    __typename?: 'MagBestContent_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type MagBestContent_Filter = {
    Content?: InputMaybe<String_Filter_Operators>;
    Image?: InputMaybe<Directus_Files_Filter>;
    Link?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<MagBestContent_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<MagBestContent_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type MagBestContent_Mutated = {
    __typename?: 'MagBestContent_mutated';
    data?: Maybe<MagBestContent>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type Mutation = {
    __typename?: 'Mutation';
    create_MagBestContent_item?: Maybe<MagBestContent>;
    create_MagBestContent_items: Array<MagBestContent>;
    create_OrganizationDetailNew_item?: Maybe<Scalars['Boolean']['output']>;
    create_OrganizationDetailNew_items?: Maybe<Scalars['Boolean']['output']>;
    create_OrganizationDetail_item?: Maybe<Scalars['Boolean']['output']>;
    create_OrganizationDetail_items?: Maybe<Scalars['Boolean']['output']>;
    create_SearchResultSupportRequests_item?: Maybe<
        Scalars['Boolean']['output']
    >;
    create_SearchResultSupportRequests_items?: Maybe<
        Scalars['Boolean']['output']
    >;
    create_ShipReserves_item?: Maybe<Scalars['Boolean']['output']>;
    create_ShipReserves_items?: Maybe<Scalars['Boolean']['output']>;
    create_ShipSearchLog_item?: Maybe<Scalars['Boolean']['output']>;
    create_ShipSearchLog_items?: Maybe<Scalars['Boolean']['output']>;
    create_TaxiReserveRequests_item?: Maybe<Scalars['Boolean']['output']>;
    create_TaxiReserveRequests_items?: Maybe<Scalars['Boolean']['output']>;
};

export type MutationCreate_MagBestContent_ItemArgs = {
    data: Create_MagBestContent_Input;
};

export type MutationCreate_MagBestContent_ItemsArgs = {
    data?: InputMaybe<Array<Create_MagBestContent_Input>>;
    filter?: InputMaybe<MagBestContent_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationCreate_OrganizationDetailNew_ItemArgs = {
    data: Create_OrganizationDetailNew_Input;
};

export type MutationCreate_OrganizationDetailNew_ItemsArgs = {
    data?: InputMaybe<Array<Create_OrganizationDetailNew_Input>>;
};

export type MutationCreate_OrganizationDetail_ItemArgs = {
    data: Create_OrganizationDetail_Input;
};

export type MutationCreate_OrganizationDetail_ItemsArgs = {
    data?: InputMaybe<Array<Create_OrganizationDetail_Input>>;
};

export type MutationCreate_SearchResultSupportRequests_ItemArgs = {
    data: Create_SearchResultSupportRequests_Input;
};

export type MutationCreate_SearchResultSupportRequests_ItemsArgs = {
    data?: InputMaybe<Array<Create_SearchResultSupportRequests_Input>>;
};

export type MutationCreate_ShipReserves_ItemArgs = {
    data: Create_ShipReserves_Input;
};

export type MutationCreate_ShipReserves_ItemsArgs = {
    data?: InputMaybe<Array<Create_ShipReserves_Input>>;
};

export type MutationCreate_ShipSearchLog_ItemArgs = {
    data: Create_ShipSearchLog_Input;
};

export type MutationCreate_ShipSearchLog_ItemsArgs = {
    data?: InputMaybe<Array<Create_ShipSearchLog_Input>>;
};

export type MutationCreate_TaxiReserveRequests_ItemArgs = {
    data: Create_TaxiReserveRequests_Input;
};

export type MutationCreate_TaxiReserveRequests_ItemsArgs = {
    data?: InputMaybe<Array<Create_TaxiReserveRequests_Input>>;
};

export type OperatorNotifications = {
    __typename?: 'OperatorNotifications';
    EndDate?: Maybe<Scalars['Date']['output']>;
    EndDate_func?: Maybe<Datetime_Functions>;
    StartDate?: Maybe<Scalars['Date']['output']>;
    StartDate_func?: Maybe<Datetime_Functions>;
    Status?: Maybe<Scalars['String']['output']>;
    Text?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    UserGroups?: Maybe<Array<Maybe<OperatorNotifications_UserGroup>>>;
    UserGroups_func?: Maybe<Count_Functions>;
    id: Scalars['ID']['output'];
};

export type OperatorNotificationsUserGroupsArgs = {
    filter?: InputMaybe<OperatorNotifications_UserGroup_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OperatorNotifications_UserGroup = {
    __typename?: 'OperatorNotifications_UserGroup';
    OperatorNotifications_id?: Maybe<OperatorNotifications>;
    UserGroup_id?: Maybe<UserGroup>;
    id: Scalars['ID']['output'];
};

export type OperatorNotifications_UserGroupOperatorNotifications_IdArgs = {
    filter?: InputMaybe<OperatorNotifications_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OperatorNotifications_UserGroupUserGroup_IdArgs = {
    filter?: InputMaybe<UserGroup_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OperatorNotifications_UserGroup_Aggregated = {
    __typename?: 'OperatorNotifications_UserGroup_aggregated';
    avg?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
    avgDistinct?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
    count?: Maybe<OperatorNotifications_UserGroup_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<OperatorNotifications_UserGroup_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
    min?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
    sum?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
    sumDistinct?: Maybe<OperatorNotifications_UserGroup_Aggregated_Fields>;
};

export type OperatorNotifications_UserGroup_Aggregated_Count = {
    __typename?: 'OperatorNotifications_UserGroup_aggregated_count';
    OperatorNotifications_id?: Maybe<Scalars['Int']['output']>;
    UserGroup_id?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type OperatorNotifications_UserGroup_Aggregated_Fields = {
    __typename?: 'OperatorNotifications_UserGroup_aggregated_fields';
    OperatorNotifications_id?: Maybe<Scalars['Float']['output']>;
    UserGroup_id?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type OperatorNotifications_UserGroup_Filter = {
    OperatorNotifications_id?: InputMaybe<OperatorNotifications_Filter>;
    UserGroup_id?: InputMaybe<UserGroup_Filter>;
    _and?: InputMaybe<
        Array<InputMaybe<OperatorNotifications_UserGroup_Filter>>
    >;
    _or?: InputMaybe<Array<InputMaybe<OperatorNotifications_UserGroup_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type OperatorNotifications_UserGroup_Mutated = {
    __typename?: 'OperatorNotifications_UserGroup_mutated';
    data?: Maybe<OperatorNotifications_UserGroup>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type OperatorNotifications_Aggregated = {
    __typename?: 'OperatorNotifications_aggregated';
    avg?: Maybe<OperatorNotifications_Aggregated_Fields>;
    avgDistinct?: Maybe<OperatorNotifications_Aggregated_Fields>;
    count?: Maybe<OperatorNotifications_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<OperatorNotifications_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<OperatorNotifications_Aggregated_Fields>;
    min?: Maybe<OperatorNotifications_Aggregated_Fields>;
    sum?: Maybe<OperatorNotifications_Aggregated_Fields>;
    sumDistinct?: Maybe<OperatorNotifications_Aggregated_Fields>;
};

export type OperatorNotifications_Aggregated_Count = {
    __typename?: 'OperatorNotifications_aggregated_count';
    EndDate?: Maybe<Scalars['Int']['output']>;
    StartDate?: Maybe<Scalars['Int']['output']>;
    Status?: Maybe<Scalars['Int']['output']>;
    Text?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    UserGroups?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type OperatorNotifications_Aggregated_Fields = {
    __typename?: 'OperatorNotifications_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type OperatorNotifications_Filter = {
    EndDate?: InputMaybe<Date_Filter_Operators>;
    EndDate_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    StartDate?: InputMaybe<Date_Filter_Operators>;
    StartDate_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    Status?: InputMaybe<String_Filter_Operators>;
    Text?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    UserGroups?: InputMaybe<OperatorNotifications_UserGroup_Filter>;
    UserGroups_func?: InputMaybe<Count_Function_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<OperatorNotifications_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<OperatorNotifications_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type OperatorNotifications_Mutated = {
    __typename?: 'OperatorNotifications_mutated';
    data?: Maybe<OperatorNotifications>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type OrganizationStatistics = {
    __typename?: 'OrganizationStatistics';
    AppInstalls?: Maybe<Scalars['Int']['output']>;
    FinalizedTickets?: Maybe<Scalars['Int']['output']>;
    TrustedOrganizations?: Maybe<Scalars['Int']['output']>;
    UniqueCustomers?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type OrganizationStatistics_Mutated = {
    __typename?: 'OrganizationStatistics_mutated';
    data?: Maybe<OrganizationStatistics>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export enum PassengerFieldsEnum {
    BirthDate = 'BirthDate',
    FirstName = 'FirstName',
    Gender = 'Gender',
    LastName = 'LastName',
    NationalCode = 'NationalCode',
    Nationality = 'Nationality',
    PassportExpiry = 'PassportExpiry',
    PassportNumber = 'PassportNumber',
    PersianFirstName = 'PersianFirstName',
    PersianLastName = 'PersianLastName',
}

export type Query = {
    __typename?: 'Query';
    ClubBrands: Array<ClubBrands>;
    ClubBrands_aggregated: Array<ClubBrands_Aggregated>;
    ClubBrands_by_id?: Maybe<ClubBrands>;
    ClubBrands_by_version?: Maybe<Version_ClubBrands>;
    ClubCategories: Array<ClubCategories>;
    ClubCategories_aggregated: Array<ClubCategories_Aggregated>;
    ClubCategories_by_id?: Maybe<ClubCategories>;
    ClubCategories_by_version?: Maybe<Version_ClubCategories>;
    ClubPrizez: Array<ClubPrizez>;
    ClubPrizez_aggregated: Array<ClubPrizez_Aggregated>;
    ClubPrizez_by_id?: Maybe<ClubPrizez>;
    ClubPrizez_by_version?: Maybe<Version_ClubPrizez>;
    MagBestContent: Array<MagBestContent>;
    MagBestContent_aggregated: Array<MagBestContent_Aggregated>;
    MagBestContent_by_id?: Maybe<MagBestContent>;
    MagBestContent_by_version?: Maybe<Version_MagBestContent>;
    OperatorNotifications: Array<OperatorNotifications>;
    OperatorNotifications_UserGroup: Array<OperatorNotifications_UserGroup>;
    OperatorNotifications_UserGroup_aggregated: Array<OperatorNotifications_UserGroup_Aggregated>;
    OperatorNotifications_UserGroup_by_id?: Maybe<OperatorNotifications_UserGroup>;
    OperatorNotifications_UserGroup_by_version?: Maybe<Version_OperatorNotifications_UserGroup>;
    OperatorNotifications_aggregated: Array<OperatorNotifications_Aggregated>;
    OperatorNotifications_by_id?: Maybe<OperatorNotifications>;
    OperatorNotifications_by_version?: Maybe<Version_OperatorNotifications>;
    OrganizationStatistics?: Maybe<OrganizationStatistics>;
    OrganizationStatistics_by_version?: Maybe<Version_OrganizationStatistics>;
    Seaports: Array<Seaports>;
    Seaports_aggregated: Array<Seaports_Aggregated>;
    Seaports_by_id?: Maybe<Seaports>;
    Seaports_by_version?: Maybe<Version_Seaports>;
    SearchResultReason: Array<SearchResultReason>;
    SearchResultReason_aggregated: Array<SearchResultReason_Aggregated>;
    SearchResultReason_by_id?: Maybe<SearchResultReason>;
    SearchResultReason_by_version?: Maybe<Version_SearchResultReason>;
    ShippingPrices: Array<ShippingPrices>;
    ShippingPrices_aggregated: Array<ShippingPrices_Aggregated>;
    ShippingPrices_by_id?: Maybe<ShippingPrices>;
    ShippingPrices_by_version?: Maybe<Version_ShippingPrices>;
    TicketingForms: Array<TicketingForms>;
    TicketingForms_aggregated: Array<TicketingForms_Aggregated>;
    TicketingForms_by_id?: Maybe<TicketingForms>;
    TicketingForms_by_version?: Maybe<Version_TicketingForms>;
    TicketingSection: Array<TicketingSection>;
    TicketingSection_TicketingTutorials: Array<TicketingSection_TicketingTutorials>;
    TicketingSection_TicketingTutorials_aggregated: Array<TicketingSection_TicketingTutorials_Aggregated>;
    TicketingSection_TicketingTutorials_by_id?: Maybe<TicketingSection_TicketingTutorials>;
    TicketingSection_TicketingTutorials_by_version?: Maybe<Version_TicketingSection_TicketingTutorials>;
    TicketingSection_aggregated: Array<TicketingSection_Aggregated>;
    TicketingSection_by_id?: Maybe<TicketingSection>;
    TicketingSection_by_version?: Maybe<Version_TicketingSection>;
    TicketingTutorials: Array<TicketingTutorials>;
    TicketingTutorials_aggregated: Array<TicketingTutorials_Aggregated>;
    TicketingTutorials_by_id?: Maybe<TicketingTutorials>;
    TicketingTutorials_by_version?: Maybe<Version_TicketingTutorials>;
    TripTerms: Array<TripTerms>;
    TripTermsCarriers: Array<TripTermsCarriers>;
    TripTermsCarriers_aggregated: Array<TripTermsCarriers_Aggregated>;
    TripTermsCarriers_by_id?: Maybe<TripTermsCarriers>;
    TripTermsCarriers_by_version?: Maybe<Version_TripTermsCarriers>;
    TripTermsProviders: Array<TripTermsProviders>;
    TripTermsProviders_aggregated: Array<TripTermsProviders_Aggregated>;
    TripTermsProviders_by_id?: Maybe<TripTermsProviders>;
    TripTermsProviders_by_version?: Maybe<Version_TripTermsProviders>;
    TripTerms_TripTermsCarriers: Array<TripTerms_TripTermsCarriers>;
    TripTerms_TripTermsCarriers_aggregated: Array<TripTerms_TripTermsCarriers_Aggregated>;
    TripTerms_TripTermsCarriers_by_id?: Maybe<TripTerms_TripTermsCarriers>;
    TripTerms_TripTermsCarriers_by_version?: Maybe<Version_TripTerms_TripTermsCarriers>;
    TripTerms_TripTermsProviders: Array<TripTerms_TripTermsProviders>;
    TripTerms_TripTermsProviders_aggregated: Array<TripTerms_TripTermsProviders_Aggregated>;
    TripTerms_TripTermsProviders_by_id?: Maybe<TripTerms_TripTermsProviders>;
    TripTerms_TripTermsProviders_by_version?: Maybe<Version_TripTerms_TripTermsProviders>;
    TripTerms_aggregated: Array<TripTerms_Aggregated>;
    TripTerms_by_id?: Maybe<TripTerms>;
    TripTerms_by_version?: Maybe<Version_TripTerms>;
    UserGroup: Array<UserGroup>;
    UserGroup_aggregated: Array<UserGroup_Aggregated>;
    UserGroup_by_id?: Maybe<UserGroup>;
    UserGroup_by_version?: Maybe<Version_UserGroup>;
    app_external_url_rule: Array<App_External_Url_Rule>;
    app_external_url_rule_aggregated: Array<App_External_Url_Rule_Aggregated>;
    app_external_url_rule_by_id?: Maybe<App_External_Url_Rule>;
    app_external_url_rule_by_version?: Maybe<Version_App_External_Url_Rule>;
    app_external_urls?: Maybe<App_External_Urls>;
    app_external_urls_by_version?: Maybe<Version_App_External_Urls>;
};

export type QueryClubBrandsArgs = {
    filter?: InputMaybe<ClubBrands_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubBrands_AggregatedArgs = {
    filter?: InputMaybe<ClubBrands_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubBrands_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryClubBrands_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryClubCategoriesArgs = {
    filter?: InputMaybe<ClubCategories_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubCategories_AggregatedArgs = {
    filter?: InputMaybe<ClubCategories_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubCategories_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryClubCategories_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryClubPrizezArgs = {
    filter?: InputMaybe<ClubPrizez_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubPrizez_AggregatedArgs = {
    filter?: InputMaybe<ClubPrizez_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClubPrizez_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryClubPrizez_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryMagBestContentArgs = {
    filter?: InputMaybe<MagBestContent_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMagBestContent_AggregatedArgs = {
    filter?: InputMaybe<MagBestContent_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMagBestContent_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryMagBestContent_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryOperatorNotificationsArgs = {
    filter?: InputMaybe<OperatorNotifications_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryOperatorNotifications_UserGroupArgs = {
    filter?: InputMaybe<OperatorNotifications_UserGroup_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryOperatorNotifications_UserGroup_AggregatedArgs = {
    filter?: InputMaybe<OperatorNotifications_UserGroup_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryOperatorNotifications_UserGroup_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryOperatorNotifications_UserGroup_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryOperatorNotifications_AggregatedArgs = {
    filter?: InputMaybe<OperatorNotifications_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryOperatorNotifications_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryOperatorNotifications_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryOrganizationStatistics_By_VersionArgs = {
    version: Scalars['String']['input'];
};

export type QuerySeaportsArgs = {
    filter?: InputMaybe<Seaports_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySeaports_AggregatedArgs = {
    filter?: InputMaybe<Seaports_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySeaports_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySeaports_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QuerySearchResultReasonArgs = {
    filter?: InputMaybe<SearchResultReason_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySearchResultReason_AggregatedArgs = {
    filter?: InputMaybe<SearchResultReason_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySearchResultReason_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QuerySearchResultReason_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryShippingPricesArgs = {
    filter?: InputMaybe<ShippingPrices_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryShippingPrices_AggregatedArgs = {
    filter?: InputMaybe<ShippingPrices_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryShippingPrices_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryShippingPrices_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTicketingFormsArgs = {
    filter?: InputMaybe<TicketingForms_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingForms_AggregatedArgs = {
    filter?: InputMaybe<TicketingForms_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingForms_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTicketingForms_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTicketingSectionArgs = {
    filter?: InputMaybe<TicketingSection_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingSection_TicketingTutorialsArgs = {
    filter?: InputMaybe<TicketingSection_TicketingTutorials_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingSection_TicketingTutorials_AggregatedArgs = {
    filter?: InputMaybe<TicketingSection_TicketingTutorials_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingSection_TicketingTutorials_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTicketingSection_TicketingTutorials_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTicketingSection_AggregatedArgs = {
    filter?: InputMaybe<TicketingSection_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingSection_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTicketingSection_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTicketingTutorialsArgs = {
    filter?: InputMaybe<TicketingTutorials_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingTutorials_AggregatedArgs = {
    filter?: InputMaybe<TicketingTutorials_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTicketingTutorials_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTicketingTutorials_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTripTermsArgs = {
    filter?: InputMaybe<TripTerms_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTermsCarriersArgs = {
    filter?: InputMaybe<TripTermsCarriers_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTermsCarriers_AggregatedArgs = {
    filter?: InputMaybe<TripTermsCarriers_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTermsCarriers_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTripTermsCarriers_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTripTermsProvidersArgs = {
    filter?: InputMaybe<TripTermsProviders_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTermsProviders_AggregatedArgs = {
    filter?: InputMaybe<TripTermsProviders_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTermsProviders_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTripTermsProviders_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTripTerms_TripTermsCarriersArgs = {
    filter?: InputMaybe<TripTerms_TripTermsCarriers_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTerms_TripTermsCarriers_AggregatedArgs = {
    filter?: InputMaybe<TripTerms_TripTermsCarriers_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTerms_TripTermsCarriers_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTripTerms_TripTermsCarriers_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTripTerms_TripTermsProvidersArgs = {
    filter?: InputMaybe<TripTerms_TripTermsProviders_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTerms_TripTermsProviders_AggregatedArgs = {
    filter?: InputMaybe<TripTerms_TripTermsProviders_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTerms_TripTermsProviders_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTripTerms_TripTermsProviders_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryTripTerms_AggregatedArgs = {
    filter?: InputMaybe<TripTerms_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTripTerms_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTripTerms_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryUserGroupArgs = {
    filter?: InputMaybe<UserGroup_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUserGroup_AggregatedArgs = {
    filter?: InputMaybe<UserGroup_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUserGroup_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryUserGroup_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryApp_External_Url_RuleArgs = {
    filter?: InputMaybe<App_External_Url_Rule_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryApp_External_Url_Rule_AggregatedArgs = {
    filter?: InputMaybe<App_External_Url_Rule_Filter>;
    groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryApp_External_Url_Rule_By_IdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryApp_External_Url_Rule_By_VersionArgs = {
    id: Scalars['ID']['input'];
    version: Scalars['String']['input'];
};

export type QueryApp_External_Urls_By_VersionArgs = {
    version: Scalars['String']['input'];
};

export type Seaports = {
    __typename?: 'Seaports';
    Code: Scalars['ID']['output'];
    CountryEnName?: Maybe<Scalars['String']['output']>;
    CountryName?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
};

export type Seaports_Aggregated = {
    __typename?: 'Seaports_aggregated';
    count?: Maybe<Seaports_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<Seaports_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
};

export type Seaports_Aggregated_Count = {
    __typename?: 'Seaports_aggregated_count';
    Code?: Maybe<Scalars['Int']['output']>;
    CountryEnName?: Maybe<Scalars['Int']['output']>;
    CountryName?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
};

export type Seaports_Filter = {
    Code?: InputMaybe<String_Filter_Operators>;
    CountryEnName?: InputMaybe<String_Filter_Operators>;
    CountryName?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<Seaports_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<Seaports_Filter>>>;
};

export type Seaports_Mutated = {
    __typename?: 'Seaports_mutated';
    data?: Maybe<Seaports>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type SearchResultReason = {
    __typename?: 'SearchResultReason';
    Description?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type SearchResultReason_Aggregated = {
    __typename?: 'SearchResultReason_aggregated';
    avg?: Maybe<SearchResultReason_Aggregated_Fields>;
    avgDistinct?: Maybe<SearchResultReason_Aggregated_Fields>;
    count?: Maybe<SearchResultReason_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<SearchResultReason_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<SearchResultReason_Aggregated_Fields>;
    min?: Maybe<SearchResultReason_Aggregated_Fields>;
    sum?: Maybe<SearchResultReason_Aggregated_Fields>;
    sumDistinct?: Maybe<SearchResultReason_Aggregated_Fields>;
};

export type SearchResultReason_Aggregated_Count = {
    __typename?: 'SearchResultReason_aggregated_count';
    Description?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type SearchResultReason_Aggregated_Fields = {
    __typename?: 'SearchResultReason_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type SearchResultReason_Filter = {
    Description?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<SearchResultReason_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<SearchResultReason_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type SearchResultReason_Mutated = {
    __typename?: 'SearchResultReason_mutated';
    data?: Maybe<SearchResultReason>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type ShippingPrices = {
    __typename?: 'ShippingPrices';
    Class?: Maybe<Scalars['String']['output']>;
    DepartureDescription?: Maybe<Scalars['String']['output']>;
    From?: Maybe<Seaports>;
    Price?: Maybe<Scalars['GraphQLBigInt']['output']>;
    RoundTrip?: Maybe<Scalars['Boolean']['output']>;
    To?: Maybe<Seaports>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type ShippingPricesFromArgs = {
    filter?: InputMaybe<Seaports_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ShippingPricesToArgs = {
    filter?: InputMaybe<Seaports_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ShippingPrices_Aggregated = {
    __typename?: 'ShippingPrices_aggregated';
    avg?: Maybe<ShippingPrices_Aggregated_Fields>;
    avgDistinct?: Maybe<ShippingPrices_Aggregated_Fields>;
    count?: Maybe<ShippingPrices_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<ShippingPrices_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<ShippingPrices_Aggregated_Fields>;
    min?: Maybe<ShippingPrices_Aggregated_Fields>;
    sum?: Maybe<ShippingPrices_Aggregated_Fields>;
    sumDistinct?: Maybe<ShippingPrices_Aggregated_Fields>;
};

export type ShippingPrices_Aggregated_Count = {
    __typename?: 'ShippingPrices_aggregated_count';
    Class?: Maybe<Scalars['Int']['output']>;
    DepartureDescription?: Maybe<Scalars['Int']['output']>;
    From?: Maybe<Scalars['Int']['output']>;
    Price?: Maybe<Scalars['Int']['output']>;
    RoundTrip?: Maybe<Scalars['Int']['output']>;
    To?: Maybe<Scalars['Int']['output']>;
    date_created?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_created?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type ShippingPrices_Aggregated_Fields = {
    __typename?: 'ShippingPrices_aggregated_fields';
    Price?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type ShippingPrices_Filter = {
    Class?: InputMaybe<String_Filter_Operators>;
    DepartureDescription?: InputMaybe<String_Filter_Operators>;
    From?: InputMaybe<Seaports_Filter>;
    Price?: InputMaybe<Number_Filter_Operators>;
    RoundTrip?: InputMaybe<Boolean_Filter_Operators>;
    To?: InputMaybe<Seaports_Filter>;
    _and?: InputMaybe<Array<InputMaybe<ShippingPrices_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<ShippingPrices_Filter>>>;
    date_created?: InputMaybe<Date_Filter_Operators>;
    date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_created?: InputMaybe<String_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type ShippingPrices_Mutated = {
    __typename?: 'ShippingPrices_mutated';
    data?: Maybe<ShippingPrices>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type Subscription = {
    __typename?: 'Subscription';
    ClubBrands_mutated?: Maybe<ClubBrands_Mutated>;
    ClubCategories_mutated?: Maybe<ClubCategories_Mutated>;
    ClubPrizez_mutated?: Maybe<ClubPrizez_Mutated>;
    MagBestContent_mutated?: Maybe<MagBestContent_Mutated>;
    OperatorNotifications_UserGroup_mutated?: Maybe<OperatorNotifications_UserGroup_Mutated>;
    OperatorNotifications_mutated?: Maybe<OperatorNotifications_Mutated>;
    OrganizationStatistics_mutated?: Maybe<OrganizationStatistics_Mutated>;
    Seaports_mutated?: Maybe<Seaports_Mutated>;
    SearchResultReason_mutated?: Maybe<SearchResultReason_Mutated>;
    ShippingPrices_mutated?: Maybe<ShippingPrices_Mutated>;
    TicketingForms_mutated?: Maybe<TicketingForms_Mutated>;
    TicketingSection_TicketingTutorials_mutated?: Maybe<TicketingSection_TicketingTutorials_Mutated>;
    TicketingSection_mutated?: Maybe<TicketingSection_Mutated>;
    TicketingTutorials_mutated?: Maybe<TicketingTutorials_Mutated>;
    TripTermsCarriers_mutated?: Maybe<TripTermsCarriers_Mutated>;
    TripTermsProviders_mutated?: Maybe<TripTermsProviders_Mutated>;
    TripTerms_TripTermsCarriers_mutated?: Maybe<TripTerms_TripTermsCarriers_Mutated>;
    TripTerms_TripTermsProviders_mutated?: Maybe<TripTerms_TripTermsProviders_Mutated>;
    TripTerms_mutated?: Maybe<TripTerms_Mutated>;
    UserGroup_mutated?: Maybe<UserGroup_Mutated>;
    app_external_url_rule_mutated?: Maybe<App_External_Url_Rule_Mutated>;
    app_external_urls_mutated?: Maybe<App_External_Urls_Mutated>;
    directus_files_mutated?: Maybe<Directus_Files_Mutated>;
};

export type SubscriptionClubBrands_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionClubCategories_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionClubPrizez_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionMagBestContent_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionOperatorNotifications_UserGroup_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionOperatorNotifications_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionOrganizationStatistics_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionSeaports_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionSearchResultReason_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionShippingPrices_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTicketingForms_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTicketingSection_TicketingTutorials_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTicketingSection_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTicketingTutorials_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTripTermsCarriers_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTripTermsProviders_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTripTerms_TripTermsCarriers_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTripTerms_TripTermsProviders_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionTripTerms_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionUserGroup_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionApp_External_Url_Rule_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionApp_External_Urls_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type SubscriptionDirectus_Files_MutatedArgs = {
    event?: InputMaybe<EventEnum>;
};

export type TicketingFaq = {
    __typename?: 'TicketingFaq';
    Description: Scalars['String']['output'];
    Title: Scalars['String']['output'];
};

export type TicketingForm = {
    __typename?: 'TicketingForm';
    Key: Scalars['String']['output'];
    Title: Scalars['String']['output'];
    Type: Scalars['String']['output'];
};

export type TicketingFormNote = {
    __typename?: 'TicketingFormNote';
    Description: Scalars['String']['output'];
};

export type TicketingFormOption = {
    __typename?: 'TicketingFormOption';
    Description: Scalars['String']['output'];
};

export type TicketingForms = {
    __typename?: 'TicketingForms';
    ForOrganizationsOnly?: Maybe<Scalars['Boolean']['output']>;
    ForeignKey?: Maybe<TicketingSection>;
    Form?: Maybe<Array<Scalars['TicketingFormJSON']['output']>>;
    Form_func?: Maybe<Count_Functions>;
    GetPassengerMode: Scalars['GetPassengerMode']['output'];
    Key: Scalars['String']['output'];
    NeedBillCode?: Maybe<Scalars['Boolean']['output']>;
    Notes?: Maybe<Array<Scalars['TicketingFormNoteJSON']['output']>>;
    Notes_func?: Maybe<Count_Functions>;
    Options?: Maybe<Array<Scalars['TicketingFormOptionJSON']['output']>>;
    Options_func?: Maybe<Count_Functions>;
    PassengerFields?: Maybe<Array<Scalars['PassengerFieldsJSON']['output']>>;
    PassengerFields_func?: Maybe<Count_Functions>;
    Title?: Maybe<Scalars['String']['output']>;
    WorkflowId?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type TicketingFormsForeignKeyArgs = {
    filter?: InputMaybe<TicketingSection_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TicketingForms_Aggregated = {
    __typename?: 'TicketingForms_aggregated';
    avg?: Maybe<TicketingForms_Aggregated_Fields>;
    avgDistinct?: Maybe<TicketingForms_Aggregated_Fields>;
    count?: Maybe<TicketingForms_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TicketingForms_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TicketingForms_Aggregated_Fields>;
    min?: Maybe<TicketingForms_Aggregated_Fields>;
    sum?: Maybe<TicketingForms_Aggregated_Fields>;
    sumDistinct?: Maybe<TicketingForms_Aggregated_Fields>;
};

export type TicketingForms_Aggregated_Count = {
    __typename?: 'TicketingForms_aggregated_count';
    ForOrganizationsOnly?: Maybe<Scalars['Int']['output']>;
    ForeignKey?: Maybe<Scalars['Int']['output']>;
    Form?: Maybe<Scalars['Int']['output']>;
    GetPassengerMode?: Maybe<Scalars['Int']['output']>;
    Key?: Maybe<Scalars['Int']['output']>;
    NeedBillCode?: Maybe<Scalars['Int']['output']>;
    Notes?: Maybe<Scalars['Int']['output']>;
    Options?: Maybe<Scalars['Int']['output']>;
    PassengerFields?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    WorkflowId?: Maybe<Scalars['Int']['output']>;
    date_created?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_created?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type TicketingForms_Aggregated_Fields = {
    __typename?: 'TicketingForms_aggregated_fields';
    ForeignKey?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type TicketingForms_Filter = {
    ForOrganizationsOnly?: InputMaybe<Boolean_Filter_Operators>;
    ForeignKey?: InputMaybe<TicketingSection_Filter>;
    Form?: InputMaybe<String_Filter_Operators>;
    Form_func?: InputMaybe<Count_Function_Filter_Operators>;
    GetPassengerMode?: InputMaybe<String_Filter_Operators>;
    Key?: InputMaybe<String_Filter_Operators>;
    NeedBillCode?: InputMaybe<Boolean_Filter_Operators>;
    Notes?: InputMaybe<String_Filter_Operators>;
    Notes_func?: InputMaybe<Count_Function_Filter_Operators>;
    Options?: InputMaybe<String_Filter_Operators>;
    Options_func?: InputMaybe<Count_Function_Filter_Operators>;
    PassengerFields?: InputMaybe<String_Filter_Operators>;
    PassengerFields_func?: InputMaybe<Count_Function_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    WorkflowId?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TicketingForms_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TicketingForms_Filter>>>;
    date_created?: InputMaybe<Date_Filter_Operators>;
    date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_created?: InputMaybe<String_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type TicketingForms_Mutated = {
    __typename?: 'TicketingForms_mutated';
    data?: Maybe<TicketingForms>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TicketingSection = {
    __typename?: 'TicketingSection';
    Faqs?: Maybe<Array<Scalars['TicketingFaqJSON']['output']>>;
    Faqs_func?: Maybe<Count_Functions>;
    Forms?: Maybe<Array<Maybe<TicketingForms>>>;
    Forms_func?: Maybe<Count_Functions>;
    Icon?: Maybe<Scalars['String']['output']>;
    Key?: Maybe<Scalars['String']['output']>;
    Pin?: Maybe<Scalars['Boolean']['output']>;
    Sort?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Tutorials?: Maybe<Array<Maybe<TicketingSection_TicketingTutorials>>>;
    Tutorials_func?: Maybe<Count_Functions>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type TicketingSectionFormsArgs = {
    filter?: InputMaybe<TicketingForms_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TicketingSectionTutorialsArgs = {
    filter?: InputMaybe<TicketingSection_TicketingTutorials_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TicketingSection_TicketingTutorials = {
    __typename?: 'TicketingSection_TicketingTutorials';
    TicketingSection_id?: Maybe<TicketingSection>;
    TicketingTutorials_id?: Maybe<TicketingTutorials>;
    id: Scalars['ID']['output'];
};

export type TicketingSection_TicketingTutorialsTicketingSection_IdArgs = {
    filter?: InputMaybe<TicketingSection_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TicketingSection_TicketingTutorialsTicketingTutorials_IdArgs = {
    filter?: InputMaybe<TicketingTutorials_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TicketingSection_TicketingTutorials_Aggregated = {
    __typename?: 'TicketingSection_TicketingTutorials_aggregated';
    avg?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
    avgDistinct?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
    count?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
    min?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
    sum?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
    sumDistinct?: Maybe<TicketingSection_TicketingTutorials_Aggregated_Fields>;
};

export type TicketingSection_TicketingTutorials_Aggregated_Count = {
    __typename?: 'TicketingSection_TicketingTutorials_aggregated_count';
    TicketingSection_id?: Maybe<Scalars['Int']['output']>;
    TicketingTutorials_id?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TicketingSection_TicketingTutorials_Aggregated_Fields = {
    __typename?: 'TicketingSection_TicketingTutorials_aggregated_fields';
    TicketingSection_id?: Maybe<Scalars['Float']['output']>;
    TicketingTutorials_id?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type TicketingSection_TicketingTutorials_Filter = {
    TicketingSection_id?: InputMaybe<TicketingSection_Filter>;
    TicketingTutorials_id?: InputMaybe<TicketingTutorials_Filter>;
    _and?: InputMaybe<
        Array<InputMaybe<TicketingSection_TicketingTutorials_Filter>>
    >;
    _or?: InputMaybe<
        Array<InputMaybe<TicketingSection_TicketingTutorials_Filter>>
    >;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TicketingSection_TicketingTutorials_Mutated = {
    __typename?: 'TicketingSection_TicketingTutorials_mutated';
    data?: Maybe<TicketingSection_TicketingTutorials>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TicketingSection_Aggregated = {
    __typename?: 'TicketingSection_aggregated';
    avg?: Maybe<TicketingSection_Aggregated_Fields>;
    avgDistinct?: Maybe<TicketingSection_Aggregated_Fields>;
    count?: Maybe<TicketingSection_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TicketingSection_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TicketingSection_Aggregated_Fields>;
    min?: Maybe<TicketingSection_Aggregated_Fields>;
    sum?: Maybe<TicketingSection_Aggregated_Fields>;
    sumDistinct?: Maybe<TicketingSection_Aggregated_Fields>;
};

export type TicketingSection_Aggregated_Count = {
    __typename?: 'TicketingSection_aggregated_count';
    Faqs?: Maybe<Scalars['Int']['output']>;
    Forms?: Maybe<Scalars['Int']['output']>;
    Icon?: Maybe<Scalars['Int']['output']>;
    Key?: Maybe<Scalars['Int']['output']>;
    Pin?: Maybe<Scalars['Int']['output']>;
    Sort?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    Tutorials?: Maybe<Scalars['Int']['output']>;
    date_created?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_created?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type TicketingSection_Aggregated_Fields = {
    __typename?: 'TicketingSection_aggregated_fields';
    Sort?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type TicketingSection_Filter = {
    Faqs?: InputMaybe<String_Filter_Operators>;
    Faqs_func?: InputMaybe<Count_Function_Filter_Operators>;
    Forms?: InputMaybe<TicketingForms_Filter>;
    Forms_func?: InputMaybe<Count_Function_Filter_Operators>;
    Icon?: InputMaybe<String_Filter_Operators>;
    Key?: InputMaybe<String_Filter_Operators>;
    Pin?: InputMaybe<Boolean_Filter_Operators>;
    Sort?: InputMaybe<Number_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    Tutorials?: InputMaybe<TicketingSection_TicketingTutorials_Filter>;
    Tutorials_func?: InputMaybe<Count_Function_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TicketingSection_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TicketingSection_Filter>>>;
    date_created?: InputMaybe<Date_Filter_Operators>;
    date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_created?: InputMaybe<String_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type TicketingSection_Mutated = {
    __typename?: 'TicketingSection_mutated';
    data?: Maybe<TicketingSection>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TicketingTutorials = {
    __typename?: 'TicketingTutorials';
    Title?: Maybe<Scalars['String']['output']>;
    Tutorial?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type TicketingTutorials_Aggregated = {
    __typename?: 'TicketingTutorials_aggregated';
    avg?: Maybe<TicketingTutorials_Aggregated_Fields>;
    avgDistinct?: Maybe<TicketingTutorials_Aggregated_Fields>;
    count?: Maybe<TicketingTutorials_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TicketingTutorials_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TicketingTutorials_Aggregated_Fields>;
    min?: Maybe<TicketingTutorials_Aggregated_Fields>;
    sum?: Maybe<TicketingTutorials_Aggregated_Fields>;
    sumDistinct?: Maybe<TicketingTutorials_Aggregated_Fields>;
};

export type TicketingTutorials_Aggregated_Count = {
    __typename?: 'TicketingTutorials_aggregated_count';
    Title?: Maybe<Scalars['Int']['output']>;
    Tutorial?: Maybe<Scalars['Int']['output']>;
    date_created?: Maybe<Scalars['Int']['output']>;
    date_updated?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    user_created?: Maybe<Scalars['Int']['output']>;
    user_updated?: Maybe<Scalars['Int']['output']>;
};

export type TicketingTutorials_Aggregated_Fields = {
    __typename?: 'TicketingTutorials_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type TicketingTutorials_Filter = {
    Title?: InputMaybe<String_Filter_Operators>;
    Tutorial?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TicketingTutorials_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TicketingTutorials_Filter>>>;
    date_created?: InputMaybe<Date_Filter_Operators>;
    date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    date_updated?: InputMaybe<Date_Filter_Operators>;
    date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    user_created?: InputMaybe<String_Filter_Operators>;
    user_updated?: InputMaybe<String_Filter_Operators>;
};

export type TicketingTutorials_Mutated = {
    __typename?: 'TicketingTutorials_mutated';
    data?: Maybe<TicketingTutorials>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TripTerms = {
    __typename?: 'TripTerms';
    Bus?: Maybe<Scalars['Boolean']['output']>;
    Carriers?: Maybe<Array<Maybe<TripTerms_TripTermsCarriers>>>;
    Carriers_func?: Maybe<Count_Functions>;
    DepartureEndDate?: Maybe<Scalars['Date']['output']>;
    DepartureEndDate_func?: Maybe<Datetime_Functions>;
    DepartureStartDate?: Maybe<Scalars['Date']['output']>;
    DepartureStartDate_func?: Maybe<Datetime_Functions>;
    Description?: Maybe<Scalars['String']['output']>;
    Flight?: Maybe<Scalars['Boolean']['output']>;
    International?: Maybe<Scalars['Boolean']['output']>;
    Providers?: Maybe<Array<Maybe<TripTerms_TripTermsProviders>>>;
    Providers_func?: Maybe<Count_Functions>;
    Train?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
};

export type TripTermsCarriersArgs = {
    filter?: InputMaybe<TripTerms_TripTermsCarriers_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTermsProvidersArgs = {
    filter?: InputMaybe<TripTerms_TripTermsProviders_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTermsCarriers = {
    __typename?: 'TripTermsCarriers';
    Code?: Maybe<Scalars['String']['output']>;
    Service?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type TripTermsCarriers_Aggregated = {
    __typename?: 'TripTermsCarriers_aggregated';
    avg?: Maybe<TripTermsCarriers_Aggregated_Fields>;
    avgDistinct?: Maybe<TripTermsCarriers_Aggregated_Fields>;
    count?: Maybe<TripTermsCarriers_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TripTermsCarriers_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TripTermsCarriers_Aggregated_Fields>;
    min?: Maybe<TripTermsCarriers_Aggregated_Fields>;
    sum?: Maybe<TripTermsCarriers_Aggregated_Fields>;
    sumDistinct?: Maybe<TripTermsCarriers_Aggregated_Fields>;
};

export type TripTermsCarriers_Aggregated_Count = {
    __typename?: 'TripTermsCarriers_aggregated_count';
    Code?: Maybe<Scalars['Int']['output']>;
    Service?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TripTermsCarriers_Aggregated_Fields = {
    __typename?: 'TripTermsCarriers_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type TripTermsCarriers_Filter = {
    Code?: InputMaybe<String_Filter_Operators>;
    Service?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TripTermsCarriers_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TripTermsCarriers_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TripTermsCarriers_Mutated = {
    __typename?: 'TripTermsCarriers_mutated';
    data?: Maybe<TripTermsCarriers>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TripTermsProviders = {
    __typename?: 'TripTermsProviders';
    Code?: Maybe<Scalars['String']['output']>;
    Service?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type TripTermsProviders_Aggregated = {
    __typename?: 'TripTermsProviders_aggregated';
    avg?: Maybe<TripTermsProviders_Aggregated_Fields>;
    avgDistinct?: Maybe<TripTermsProviders_Aggregated_Fields>;
    count?: Maybe<TripTermsProviders_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TripTermsProviders_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TripTermsProviders_Aggregated_Fields>;
    min?: Maybe<TripTermsProviders_Aggregated_Fields>;
    sum?: Maybe<TripTermsProviders_Aggregated_Fields>;
    sumDistinct?: Maybe<TripTermsProviders_Aggregated_Fields>;
};

export type TripTermsProviders_Aggregated_Count = {
    __typename?: 'TripTermsProviders_aggregated_count';
    Code?: Maybe<Scalars['Int']['output']>;
    Service?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TripTermsProviders_Aggregated_Fields = {
    __typename?: 'TripTermsProviders_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type TripTermsProviders_Filter = {
    Code?: InputMaybe<String_Filter_Operators>;
    Service?: InputMaybe<String_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TripTermsProviders_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TripTermsProviders_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TripTermsProviders_Mutated = {
    __typename?: 'TripTermsProviders_mutated';
    data?: Maybe<TripTermsProviders>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TripTerms_TripTermsCarriers = {
    __typename?: 'TripTerms_TripTermsCarriers';
    TripTermsCarriers_id?: Maybe<TripTermsCarriers>;
    TripTerms_id?: Maybe<TripTerms>;
    id: Scalars['ID']['output'];
};

export type TripTerms_TripTermsCarriersTripTermsCarriers_IdArgs = {
    filter?: InputMaybe<TripTermsCarriers_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTerms_TripTermsCarriersTripTerms_IdArgs = {
    filter?: InputMaybe<TripTerms_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTerms_TripTermsCarriers_Aggregated = {
    __typename?: 'TripTerms_TripTermsCarriers_aggregated';
    avg?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
    avgDistinct?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
    count?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
    min?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
    sum?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
    sumDistinct?: Maybe<TripTerms_TripTermsCarriers_Aggregated_Fields>;
};

export type TripTerms_TripTermsCarriers_Aggregated_Count = {
    __typename?: 'TripTerms_TripTermsCarriers_aggregated_count';
    TripTermsCarriers_id?: Maybe<Scalars['Int']['output']>;
    TripTerms_id?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TripTerms_TripTermsCarriers_Aggregated_Fields = {
    __typename?: 'TripTerms_TripTermsCarriers_aggregated_fields';
    TripTermsCarriers_id?: Maybe<Scalars['Float']['output']>;
    TripTerms_id?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type TripTerms_TripTermsCarriers_Filter = {
    TripTermsCarriers_id?: InputMaybe<TripTermsCarriers_Filter>;
    TripTerms_id?: InputMaybe<TripTerms_Filter>;
    _and?: InputMaybe<Array<InputMaybe<TripTerms_TripTermsCarriers_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TripTerms_TripTermsCarriers_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TripTerms_TripTermsCarriers_Mutated = {
    __typename?: 'TripTerms_TripTermsCarriers_mutated';
    data?: Maybe<TripTerms_TripTermsCarriers>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TripTerms_TripTermsProviders = {
    __typename?: 'TripTerms_TripTermsProviders';
    TripTermsProviders_id?: Maybe<TripTermsProviders>;
    TripTerms_id?: Maybe<TripTerms>;
    id: Scalars['ID']['output'];
};

export type TripTerms_TripTermsProvidersTripTermsProviders_IdArgs = {
    filter?: InputMaybe<TripTermsProviders_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTerms_TripTermsProvidersTripTerms_IdArgs = {
    filter?: InputMaybe<TripTerms_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TripTerms_TripTermsProviders_Aggregated = {
    __typename?: 'TripTerms_TripTermsProviders_aggregated';
    avg?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
    avgDistinct?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
    count?: Maybe<TripTerms_TripTermsProviders_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TripTerms_TripTermsProviders_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
    min?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
    sum?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
    sumDistinct?: Maybe<TripTerms_TripTermsProviders_Aggregated_Fields>;
};

export type TripTerms_TripTermsProviders_Aggregated_Count = {
    __typename?: 'TripTerms_TripTermsProviders_aggregated_count';
    TripTermsProviders_id?: Maybe<Scalars['Int']['output']>;
    TripTerms_id?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TripTerms_TripTermsProviders_Aggregated_Fields = {
    __typename?: 'TripTerms_TripTermsProviders_aggregated_fields';
    TripTermsProviders_id?: Maybe<Scalars['Float']['output']>;
    TripTerms_id?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type TripTerms_TripTermsProviders_Filter = {
    TripTermsProviders_id?: InputMaybe<TripTermsProviders_Filter>;
    TripTerms_id?: InputMaybe<TripTerms_Filter>;
    _and?: InputMaybe<Array<InputMaybe<TripTerms_TripTermsProviders_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TripTerms_TripTermsProviders_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TripTerms_TripTermsProviders_Mutated = {
    __typename?: 'TripTerms_TripTermsProviders_mutated';
    data?: Maybe<TripTerms_TripTermsProviders>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type TripTerms_Aggregated = {
    __typename?: 'TripTerms_aggregated';
    avg?: Maybe<TripTerms_Aggregated_Fields>;
    avgDistinct?: Maybe<TripTerms_Aggregated_Fields>;
    count?: Maybe<TripTerms_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<TripTerms_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<TripTerms_Aggregated_Fields>;
    min?: Maybe<TripTerms_Aggregated_Fields>;
    sum?: Maybe<TripTerms_Aggregated_Fields>;
    sumDistinct?: Maybe<TripTerms_Aggregated_Fields>;
};

export type TripTerms_Aggregated_Count = {
    __typename?: 'TripTerms_aggregated_count';
    Bus?: Maybe<Scalars['Int']['output']>;
    Carriers?: Maybe<Scalars['Int']['output']>;
    DepartureEndDate?: Maybe<Scalars['Int']['output']>;
    DepartureStartDate?: Maybe<Scalars['Int']['output']>;
    Description?: Maybe<Scalars['Int']['output']>;
    Flight?: Maybe<Scalars['Int']['output']>;
    International?: Maybe<Scalars['Int']['output']>;
    Providers?: Maybe<Scalars['Int']['output']>;
    Train?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type TripTerms_Aggregated_Fields = {
    __typename?: 'TripTerms_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
};

export type TripTerms_Filter = {
    Bus?: InputMaybe<Boolean_Filter_Operators>;
    Carriers?: InputMaybe<TripTerms_TripTermsCarriers_Filter>;
    Carriers_func?: InputMaybe<Count_Function_Filter_Operators>;
    DepartureEndDate?: InputMaybe<Date_Filter_Operators>;
    DepartureEndDate_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    DepartureStartDate?: InputMaybe<Date_Filter_Operators>;
    DepartureStartDate_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    Description?: InputMaybe<String_Filter_Operators>;
    Flight?: InputMaybe<Boolean_Filter_Operators>;
    International?: InputMaybe<Boolean_Filter_Operators>;
    Providers?: InputMaybe<TripTerms_TripTermsProviders_Filter>;
    Providers_func?: InputMaybe<Count_Function_Filter_Operators>;
    Train?: InputMaybe<Boolean_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<TripTerms_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<TripTerms_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type TripTerms_Mutated = {
    __typename?: 'TripTerms_mutated';
    data?: Maybe<TripTerms>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type UserGroup = {
    __typename?: 'UserGroup';
    GroupID: Scalars['Int']['output'];
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type UserGroup_Aggregated = {
    __typename?: 'UserGroup_aggregated';
    avg?: Maybe<UserGroup_Aggregated_Fields>;
    avgDistinct?: Maybe<UserGroup_Aggregated_Fields>;
    count?: Maybe<UserGroup_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<UserGroup_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<UserGroup_Aggregated_Fields>;
    min?: Maybe<UserGroup_Aggregated_Fields>;
    sum?: Maybe<UserGroup_Aggregated_Fields>;
    sumDistinct?: Maybe<UserGroup_Aggregated_Fields>;
};

export type UserGroup_Aggregated_Count = {
    __typename?: 'UserGroup_aggregated_count';
    GroupID?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type UserGroup_Aggregated_Fields = {
    __typename?: 'UserGroup_aggregated_fields';
    GroupID?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type UserGroup_Filter = {
    GroupID?: InputMaybe<Number_Filter_Operators>;
    Title?: InputMaybe<String_Filter_Operators>;
    _and?: InputMaybe<Array<InputMaybe<UserGroup_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<UserGroup_Filter>>>;
    id?: InputMaybe<Number_Filter_Operators>;
};

export type UserGroup_Mutated = {
    __typename?: 'UserGroup_mutated';
    data?: Maybe<UserGroup>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type App_External_Url_Rule = {
    __typename?: 'app_external_url_rule';
    behavior?: Maybe<Scalars['String']['output']>;
    case_sensitive?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    is_regex?: Maybe<Scalars['Boolean']['output']>;
    pattern?: Maybe<Scalars['String']['output']>;
    sort?: Maybe<Scalars['Int']['output']>;
    url_rules?: Maybe<App_External_Urls>;
};

export type App_External_Url_RuleUrl_RulesArgs = {
    filter?: InputMaybe<App_External_Urls_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type App_External_Url_Rule_Aggregated = {
    __typename?: 'app_external_url_rule_aggregated';
    avg?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
    avgDistinct?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
    count?: Maybe<App_External_Url_Rule_Aggregated_Count>;
    countAll?: Maybe<Scalars['Int']['output']>;
    countDistinct?: Maybe<App_External_Url_Rule_Aggregated_Count>;
    group?: Maybe<Scalars['JSON']['output']>;
    max?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
    min?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
    sum?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
    sumDistinct?: Maybe<App_External_Url_Rule_Aggregated_Fields>;
};

export type App_External_Url_Rule_Aggregated_Count = {
    __typename?: 'app_external_url_rule_aggregated_count';
    behavior?: Maybe<Scalars['Int']['output']>;
    case_sensitive?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    is_regex?: Maybe<Scalars['Int']['output']>;
    pattern?: Maybe<Scalars['Int']['output']>;
    sort?: Maybe<Scalars['Int']['output']>;
    url_rules?: Maybe<Scalars['Int']['output']>;
};

export type App_External_Url_Rule_Aggregated_Fields = {
    __typename?: 'app_external_url_rule_aggregated_fields';
    id?: Maybe<Scalars['Float']['output']>;
    sort?: Maybe<Scalars['Float']['output']>;
    url_rules?: Maybe<Scalars['Float']['output']>;
};

export type App_External_Url_Rule_Filter = {
    _and?: InputMaybe<Array<InputMaybe<App_External_Url_Rule_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<App_External_Url_Rule_Filter>>>;
    behavior?: InputMaybe<String_Filter_Operators>;
    case_sensitive?: InputMaybe<Boolean_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    is_regex?: InputMaybe<Boolean_Filter_Operators>;
    pattern?: InputMaybe<String_Filter_Operators>;
    sort?: InputMaybe<Number_Filter_Operators>;
    url_rules?: InputMaybe<App_External_Urls_Filter>;
};

export type App_External_Url_Rule_Mutated = {
    __typename?: 'app_external_url_rule_mutated';
    data?: Maybe<App_External_Url_Rule>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type App_External_Urls = {
    __typename?: 'app_external_urls';
    default_behavior?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    url_rules?: Maybe<Array<Maybe<App_External_Url_Rule>>>;
    url_rules_func?: Maybe<Count_Functions>;
};

export type App_External_UrlsUrl_RulesArgs = {
    filter?: InputMaybe<App_External_Url_Rule_Filter>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
    sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type App_External_Urls_Filter = {
    _and?: InputMaybe<Array<InputMaybe<App_External_Urls_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<App_External_Urls_Filter>>>;
    default_behavior?: InputMaybe<String_Filter_Operators>;
    id?: InputMaybe<Number_Filter_Operators>;
    url_rules?: InputMaybe<App_External_Url_Rule_Filter>;
    url_rules_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type App_External_Urls_Mutated = {
    __typename?: 'app_external_urls_mutated';
    data?: Maybe<App_External_Urls>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type Boolean_Filter_Operators = {
    _eq?: InputMaybe<Scalars['Boolean']['input']>;
    _neq?: InputMaybe<Scalars['Boolean']['input']>;
    _nnull?: InputMaybe<Scalars['Boolean']['input']>;
    _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Count_Function_Filter_Operators = {
    count?: InputMaybe<Number_Filter_Operators>;
};

export type Count_Functions = {
    __typename?: 'count_functions';
    count?: Maybe<Scalars['Int']['output']>;
};

export type Create_MagBestContent_Input = {
    Content?: InputMaybe<Scalars['String']['input']>;
    Image?: InputMaybe<Create_Directus_Files_Input>;
    Link?: InputMaybe<Scalars['String']['input']>;
    Title?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    user_updated?: InputMaybe<Scalars['String']['input']>;
};

export type Create_OrganizationDetailNew_Input = {
    CallNumber?: InputMaybe<Scalars['String']['input']>;
    Description?: InputMaybe<Scalars['String']['input']>;
    GiftCardCount?: InputMaybe<Scalars['Int']['input']>;
    GiftCardCredit?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
    Name?: InputMaybe<Scalars['String']['input']>;
    OrganizationName?: InputMaybe<Scalars['String']['input']>;
    Source?: InputMaybe<Scalars['String']['input']>;
    Status?: InputMaybe<Scalars['String']['input']>;
    date_created?: InputMaybe<Scalars['Date']['input']>;
    date_updated?: InputMaybe<Scalars['Date']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    user_created?: InputMaybe<Scalars['String']['input']>;
    user_updated?: InputMaybe<Scalars['String']['input']>;
};

export type Create_OrganizationDetail_Input = {
    CallNumber: Scalars['ID']['input'];
    Description?: InputMaybe<Scalars['String']['input']>;
    GiftCardCount?: InputMaybe<Scalars['Int']['input']>;
    GiftCardCredit?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
    Name?: InputMaybe<Scalars['String']['input']>;
    OrganizationName?: InputMaybe<Scalars['String']['input']>;
    Source?: InputMaybe<Scalars['String']['input']>;
    date_created?: InputMaybe<Scalars['Date']['input']>;
    date_updated?: InputMaybe<Scalars['Date']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    user_created?: InputMaybe<Scalars['String']['input']>;
    user_updated?: InputMaybe<Scalars['String']['input']>;
};

export type Create_SearchResultSupportRequests_Input = {
    Description?: InputMaybe<Scalars['String']['input']>;
    FirstName?: InputMaybe<Scalars['String']['input']>;
    IsChecked?: InputMaybe<Scalars['Boolean']['input']>;
    LastName?: InputMaybe<Scalars['String']['input']>;
    Mobile?: InputMaybe<Scalars['String']['input']>;
    Reason?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_ShipReserves_Input = {
    AdultCount?: InputMaybe<Scalars['Int']['input']>;
    CarCount?: InputMaybe<Scalars['Int']['input']>;
    ChildCount?: InputMaybe<Scalars['Int']['input']>;
    DepartureDate?: InputMaybe<Scalars['String']['input']>;
    Description?: InputMaybe<Scalars['String']['input']>;
    Destination?: InputMaybe<Scalars['String']['input']>;
    Finalized?: InputMaybe<Scalars['Boolean']['input']>;
    Fullname?: InputMaybe<Scalars['String']['input']>;
    InfantCount?: InputMaybe<Scalars['Int']['input']>;
    Origin?: InputMaybe<Scalars['String']['input']>;
    Phonenumber?: InputMaybe<Scalars['String']['input']>;
    ReturnDate?: InputMaybe<Scalars['String']['input']>;
    Reviewed?: InputMaybe<Scalars['Boolean']['input']>;
    date_created?: InputMaybe<Scalars['Date']['input']>;
    date_updated?: InputMaybe<Scalars['Date']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_ShipSearchLog_Input = {
    From?: InputMaybe<Scalars['String']['input']>;
    IsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
    To?: InputMaybe<Scalars['String']['input']>;
    aaaa?: InputMaybe<Scalars['JSON']['input']>;
    date_created?: InputMaybe<Scalars['Date']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_TaxiReserveRequests_Input = {
    departureTime?: InputMaybe<Scalars['Date']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    mobileNumber?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    route?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Directus_Files_Input = {
    charset?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    duration?: InputMaybe<Scalars['Int']['input']>;
    embed?: InputMaybe<Scalars['String']['input']>;
    filename_disk?: InputMaybe<Scalars['String']['input']>;
    filename_download: Scalars['String']['input'];
    filesize?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
    folder?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    modified_by?: InputMaybe<Scalars['String']['input']>;
    modified_on?: InputMaybe<Scalars['Date']['input']>;
    storage: Scalars['String']['input'];
    tags?: InputMaybe<Scalars['JSON']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
    uploaded_by?: InputMaybe<Scalars['String']['input']>;
    uploaded_on?: InputMaybe<Scalars['Date']['input']>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

export type Date_Filter_Operators = {
    _between?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _eq?: InputMaybe<Scalars['String']['input']>;
    _gt?: InputMaybe<Scalars['String']['input']>;
    _gte?: InputMaybe<Scalars['String']['input']>;
    _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    _lt?: InputMaybe<Scalars['String']['input']>;
    _lte?: InputMaybe<Scalars['String']['input']>;
    _nbetween?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _neq?: InputMaybe<Scalars['String']['input']>;
    _nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    _nnull?: InputMaybe<Scalars['Boolean']['input']>;
    _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Datetime_Function_Filter_Operators = {
    day?: InputMaybe<Number_Filter_Operators>;
    hour?: InputMaybe<Number_Filter_Operators>;
    minute?: InputMaybe<Number_Filter_Operators>;
    month?: InputMaybe<Number_Filter_Operators>;
    second?: InputMaybe<Number_Filter_Operators>;
    week?: InputMaybe<Number_Filter_Operators>;
    weekday?: InputMaybe<Number_Filter_Operators>;
    year?: InputMaybe<Number_Filter_Operators>;
};

export type Datetime_Functions = {
    __typename?: 'datetime_functions';
    day?: Maybe<Scalars['Int']['output']>;
    hour?: Maybe<Scalars['Int']['output']>;
    minute?: Maybe<Scalars['Int']['output']>;
    month?: Maybe<Scalars['Int']['output']>;
    second?: Maybe<Scalars['Int']['output']>;
    week?: Maybe<Scalars['Int']['output']>;
    weekday?: Maybe<Scalars['Int']['output']>;
    year?: Maybe<Scalars['Int']['output']>;
};

export type Directus_Files = {
    __typename?: 'directus_files';
    charset?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    duration?: Maybe<Scalars['Int']['output']>;
    embed?: Maybe<Scalars['String']['output']>;
    filename_disk?: Maybe<Scalars['String']['output']>;
    filename_download: Scalars['String']['output'];
    filesize?: Maybe<Scalars['GraphQLBigInt']['output']>;
    folder?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    location?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    metadata_func?: Maybe<Count_Functions>;
    modified_by?: Maybe<Scalars['String']['output']>;
    modified_on?: Maybe<Scalars['Date']['output']>;
    modified_on_func?: Maybe<Datetime_Functions>;
    storage: Scalars['String']['output'];
    tags?: Maybe<Scalars['JSON']['output']>;
    tags_func?: Maybe<Count_Functions>;
    title?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    uploaded_by?: Maybe<Scalars['String']['output']>;
    uploaded_on?: Maybe<Scalars['Date']['output']>;
    uploaded_on_func?: Maybe<Datetime_Functions>;
    width?: Maybe<Scalars['Int']['output']>;
};

export type Directus_Files_Filter = {
    _and?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
    _or?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
    charset?: InputMaybe<String_Filter_Operators>;
    description?: InputMaybe<String_Filter_Operators>;
    duration?: InputMaybe<Number_Filter_Operators>;
    embed?: InputMaybe<String_Filter_Operators>;
    filename_disk?: InputMaybe<String_Filter_Operators>;
    filename_download?: InputMaybe<String_Filter_Operators>;
    filesize?: InputMaybe<Number_Filter_Operators>;
    folder?: InputMaybe<String_Filter_Operators>;
    height?: InputMaybe<Number_Filter_Operators>;
    id?: InputMaybe<String_Filter_Operators>;
    location?: InputMaybe<String_Filter_Operators>;
    metadata?: InputMaybe<String_Filter_Operators>;
    metadata_func?: InputMaybe<Count_Function_Filter_Operators>;
    modified_by?: InputMaybe<String_Filter_Operators>;
    modified_on?: InputMaybe<Date_Filter_Operators>;
    modified_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    storage?: InputMaybe<String_Filter_Operators>;
    tags?: InputMaybe<String_Filter_Operators>;
    tags_func?: InputMaybe<Count_Function_Filter_Operators>;
    title?: InputMaybe<String_Filter_Operators>;
    type?: InputMaybe<String_Filter_Operators>;
    uploaded_by?: InputMaybe<String_Filter_Operators>;
    uploaded_on?: InputMaybe<Date_Filter_Operators>;
    uploaded_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
    width?: InputMaybe<Number_Filter_Operators>;
};

export type Directus_Files_Mutated = {
    __typename?: 'directus_files_mutated';
    data?: Maybe<Directus_Files>;
    event?: Maybe<EventEnum>;
    key: Scalars['ID']['output'];
};

export type Number_Filter_Operators = {
    _between?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _eq?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _gt?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _gte?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _in?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _lt?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _lte?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _nbetween?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _neq?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
    _nin?: InputMaybe<
        Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>
    >;
    _nnull?: InputMaybe<Scalars['Boolean']['input']>;
    _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type String_Filter_Operators = {
    _contains?: InputMaybe<Scalars['String']['input']>;
    _empty?: InputMaybe<Scalars['Boolean']['input']>;
    _ends_with?: InputMaybe<Scalars['String']['input']>;
    _eq?: InputMaybe<Scalars['String']['input']>;
    _icontains?: InputMaybe<Scalars['String']['input']>;
    _iends_with?: InputMaybe<Scalars['String']['input']>;
    _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    _istarts_with?: InputMaybe<Scalars['String']['input']>;
    _ncontains?: InputMaybe<Scalars['String']['input']>;
    _nempty?: InputMaybe<Scalars['Boolean']['input']>;
    _nends_with?: InputMaybe<Scalars['String']['input']>;
    _neq?: InputMaybe<Scalars['String']['input']>;
    _niends_with?: InputMaybe<Scalars['String']['input']>;
    _nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    _nistarts_with?: InputMaybe<Scalars['String']['input']>;
    _nnull?: InputMaybe<Scalars['Boolean']['input']>;
    _nstarts_with?: InputMaybe<Scalars['String']['input']>;
    _null?: InputMaybe<Scalars['Boolean']['input']>;
    _starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type Version_ClubBrands = {
    __typename?: 'version_ClubBrands';
    Icon?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_ClubCategories = {
    __typename?: 'version_ClubCategories';
    Icon?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    sort?: Maybe<Scalars['Int']['output']>;
};

export type Version_ClubPrizez = {
    __typename?: 'version_ClubPrizez';
    BrandId?: Maybe<Scalars['Int']['output']>;
    Category?: Maybe<Scalars['Int']['output']>;
    Description?: Maybe<Scalars['String']['output']>;
    ExpireDate?: Maybe<Scalars['Date']['output']>;
    ExpireDate_func?: Maybe<Datetime_Functions>;
    HasDiscount?: Maybe<Scalars['Boolean']['output']>;
    Link?: Maybe<Scalars['String']['output']>;
    LinkTitle?: Maybe<Scalars['String']['output']>;
    Score?: Maybe<Scalars['Int']['output']>;
    ScoreDescription?: Maybe<Scalars['String']['output']>;
    UsedCount?: Maybe<Scalars['Int']['output']>;
    UserLevel?: Maybe<Scalars['String']['output']>;
    UserType?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_MagBestContent = {
    __typename?: 'version_MagBestContent';
    Content?: Maybe<Scalars['String']['output']>;
    Image?: Maybe<Scalars['String']['output']>;
    Link?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_OperatorNotifications = {
    __typename?: 'version_OperatorNotifications';
    EndDate?: Maybe<Scalars['Date']['output']>;
    EndDate_func?: Maybe<Datetime_Functions>;
    StartDate?: Maybe<Scalars['Date']['output']>;
    StartDate_func?: Maybe<Datetime_Functions>;
    Status?: Maybe<Scalars['String']['output']>;
    Text?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    UserGroups?: Maybe<Scalars['JSON']['output']>;
    UserGroups_func?: Maybe<Count_Functions>;
    id: Scalars['ID']['output'];
};

export type Version_OperatorNotifications_UserGroup = {
    __typename?: 'version_OperatorNotifications_UserGroup';
    OperatorNotifications_id?: Maybe<Scalars['Int']['output']>;
    UserGroup_id?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_OrganizationStatistics = {
    __typename?: 'version_OrganizationStatistics';
    AppInstalls?: Maybe<Scalars['Int']['output']>;
    FinalizedTickets?: Maybe<Scalars['Int']['output']>;
    TrustedOrganizations?: Maybe<Scalars['Int']['output']>;
    UniqueCustomers?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_Seaports = {
    __typename?: 'version_Seaports';
    Code: Scalars['ID']['output'];
    CountryEnName?: Maybe<Scalars['String']['output']>;
    CountryName?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
};

export type Version_SearchResultReason = {
    __typename?: 'version_SearchResultReason';
    Description?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_ShippingPrices = {
    __typename?: 'version_ShippingPrices';
    Class?: Maybe<Scalars['String']['output']>;
    DepartureDescription?: Maybe<Scalars['String']['output']>;
    From?: Maybe<Scalars['String']['output']>;
    Price?: Maybe<Scalars['GraphQLBigInt']['output']>;
    RoundTrip?: Maybe<Scalars['Boolean']['output']>;
    To?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_TicketingForms = {
    __typename?: 'version_TicketingForms';
    ForOrganizationsOnly?: Maybe<Scalars['Boolean']['output']>;
    ForeignKey?: Maybe<Scalars['Int']['output']>;
    Form?: Maybe<Scalars['JSON']['output']>;
    Form_func?: Maybe<Count_Functions>;
    GetPassengerMode?: Maybe<Scalars['String']['output']>;
    Key: Scalars['String']['output'];
    NeedBillCode?: Maybe<Scalars['Boolean']['output']>;
    Notes?: Maybe<Scalars['JSON']['output']>;
    Notes_func?: Maybe<Count_Functions>;
    Options?: Maybe<Scalars['JSON']['output']>;
    Options_func?: Maybe<Count_Functions>;
    PassengerFields?: Maybe<Scalars['JSON']['output']>;
    PassengerFields_func?: Maybe<Count_Functions>;
    Title?: Maybe<Scalars['String']['output']>;
    WorkflowId?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_TicketingSection = {
    __typename?: 'version_TicketingSection';
    Faqs?: Maybe<Scalars['JSON']['output']>;
    Faqs_func?: Maybe<Count_Functions>;
    Forms?: Maybe<Scalars['JSON']['output']>;
    Forms_func?: Maybe<Count_Functions>;
    Icon?: Maybe<Scalars['String']['output']>;
    Key?: Maybe<Scalars['String']['output']>;
    Pin?: Maybe<Scalars['Boolean']['output']>;
    Sort?: Maybe<Scalars['Int']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    Tutorials?: Maybe<Scalars['JSON']['output']>;
    Tutorials_func?: Maybe<Count_Functions>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_TicketingSection_TicketingTutorials = {
    __typename?: 'version_TicketingSection_TicketingTutorials';
    TicketingSection_id?: Maybe<Scalars['Int']['output']>;
    TicketingTutorials_id?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_TicketingTutorials = {
    __typename?: 'version_TicketingTutorials';
    Title?: Maybe<Scalars['String']['output']>;
    Tutorial?: Maybe<Scalars['String']['output']>;
    date_created?: Maybe<Scalars['Date']['output']>;
    date_created_func?: Maybe<Datetime_Functions>;
    date_updated?: Maybe<Scalars['Date']['output']>;
    date_updated_func?: Maybe<Datetime_Functions>;
    id: Scalars['ID']['output'];
    user_created?: Maybe<Scalars['String']['output']>;
    user_updated?: Maybe<Scalars['String']['output']>;
};

export type Version_TripTerms = {
    __typename?: 'version_TripTerms';
    Bus?: Maybe<Scalars['Boolean']['output']>;
    Carriers?: Maybe<Scalars['JSON']['output']>;
    Carriers_func?: Maybe<Count_Functions>;
    DepartureEndDate?: Maybe<Scalars['Date']['output']>;
    DepartureEndDate_func?: Maybe<Datetime_Functions>;
    DepartureStartDate?: Maybe<Scalars['Date']['output']>;
    DepartureStartDate_func?: Maybe<Datetime_Functions>;
    Description?: Maybe<Scalars['String']['output']>;
    Flight?: Maybe<Scalars['Boolean']['output']>;
    International?: Maybe<Scalars['Boolean']['output']>;
    Providers?: Maybe<Scalars['JSON']['output']>;
    Providers_func?: Maybe<Count_Functions>;
    Train?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_TripTermsCarriers = {
    __typename?: 'version_TripTermsCarriers';
    Code?: Maybe<Scalars['String']['output']>;
    Service?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_TripTermsProviders = {
    __typename?: 'version_TripTermsProviders';
    Code?: Maybe<Scalars['String']['output']>;
    Service?: Maybe<Scalars['String']['output']>;
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_TripTerms_TripTermsCarriers = {
    __typename?: 'version_TripTerms_TripTermsCarriers';
    TripTermsCarriers_id?: Maybe<Scalars['Int']['output']>;
    TripTerms_id?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_TripTerms_TripTermsProviders = {
    __typename?: 'version_TripTerms_TripTermsProviders';
    TripTermsProviders_id?: Maybe<Scalars['Int']['output']>;
    TripTerms_id?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_UserGroup = {
    __typename?: 'version_UserGroup';
    GroupID: Scalars['Int']['output'];
    Title?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
};

export type Version_App_External_Url_Rule = {
    __typename?: 'version_app_external_url_rule';
    behavior?: Maybe<Scalars['String']['output']>;
    case_sensitive?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    is_regex?: Maybe<Scalars['Boolean']['output']>;
    pattern?: Maybe<Scalars['String']['output']>;
    sort?: Maybe<Scalars['Int']['output']>;
    url_rules?: Maybe<Scalars['Int']['output']>;
};

export type Version_App_External_Urls = {
    __typename?: 'version_app_external_urls';
    default_behavior?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    url_rules?: Maybe<Scalars['JSON']['output']>;
    url_rules_func?: Maybe<Count_Functions>;
};

export type OrganizationDetailMutationVariables = Exact<{
    CallNumber: Scalars['String']['input'];
    Description: Scalars['String']['input'];
    Name: Scalars['String']['input'];
    OrganizationName: Scalars['String']['input'];
    Source?: InputMaybe<Scalars['String']['input']>;
    GiftCardCount?: InputMaybe<Scalars['Int']['input']>;
    GiftCardCredit?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
}>;

export type OrganizationDetailMutation = {
    __typename?: 'Mutation';
    create_OrganizationDetailNew_item?: boolean | null;
};

export type SearchResultSupportRequestMutationVariables = Exact<{
    Description: Scalars['String']['input'];
    FirstName: Scalars['String']['input'];
    LastName: Scalars['String']['input'];
    Mobile: Scalars['String']['input'];
    Reason: Scalars['Int']['input'];
}>;

export type SearchResultSupportRequestMutation = {
    __typename?: 'Mutation';
    create_SearchResultSupportRequests_item?: boolean | null;
};

export type ShipReserveMutationVariables = Exact<{
    AdultCount: Scalars['Int']['input'];
    ChildCount: Scalars['Int']['input'];
    InfantCount: Scalars['Int']['input'];
    CarCount: Scalars['Int']['input'];
    Origin: Scalars['String']['input'];
    Destination: Scalars['String']['input'];
    DepartureDate: Scalars['String']['input'];
    ReturnDate?: InputMaybe<Scalars['String']['input']>;
    FullName: Scalars['String']['input'];
    PhoneNumber: Scalars['String']['input'];
}>;

export type ShipReserveMutation = {
    __typename?: 'Mutation';
    create_ShipReserves_item?: boolean | null;
};

export type ShipSearchLogMutationVariables = Exact<{
    To: Scalars['String']['input'];
    From: Scalars['String']['input'];
    IsAvailable: Scalars['Boolean']['input'];
}>;

export type ShipSearchLogMutation = {
    __typename?: 'Mutation';
    create_ShipSearchLog_item?: boolean | null;
};

export type TaxiReserveMutationVariables = Exact<{
    departureTime: Scalars['Date']['input'];
    mobileNumber: Scalars['String']['input'];
    name: Scalars['String']['input'];
    route: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
}>;

export type TaxiReserveMutation = {
    __typename?: 'Mutation';
    create_TaxiReserveRequests_item?: boolean | null;
};

export type ClubCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type ClubCategoriesQuery = {
    __typename?: 'Query';
    ClubCategories: Array<{
        __typename?: 'ClubCategories';
        Title?: string | null;
        id: string;
        Icon?: string | null;
    }>;
};

export type ClubPrizesQueryVariables = Exact<{
    UserType: Scalars['String']['input'];
    UserLevel: Scalars['String']['input'];
}>;

export type ClubPrizesQuery = {
    __typename?: 'Query';
    ClubPrizez: Array<{
        __typename?: 'ClubPrizez';
        id: string;
        Description?: string | null;
        Link?: string | null;
        date_created?: string | null;
        ExpireDate?: string | null;
        HasDiscount?: boolean | null;
        LinkTitle?: string | null;
        Score?: number | null;
        ScoreDescription?: string | null;
        UsedCount?: number | null;
        BrandId?: {
            __typename?: 'ClubBrands';
            id: string;
            Title?: string | null;
            Icon?: {
                __typename?: 'directus_files';
                filename_disk?: string | null;
                id: string;
            } | null;
        } | null;
        Category?: {
            __typename?: 'ClubCategories';
            id: string;
            Title?: string | null;
            Icon?: string | null;
        } | null;
    }>;
};

export type MagBestContentQueryVariables = Exact<{ [key: string]: never }>;

export type MagBestContentQuery = {
    __typename?: 'Query';
    MagBestContent: Array<{
        __typename?: 'MagBestContent';
        Title?: string | null;
        id: string;
        Content?: string | null;
        Link?: string | null;
        Image?: {
            __typename?: 'directus_files';
            title?: string | null;
            id: string;
        } | null;
    }>;
};

export type OrganizationStatisticsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type OrganizationStatisticsQuery = {
    __typename?: 'Query';
    OrganizationStatistics?: {
        __typename?: 'OrganizationStatistics';
        id: string;
        AppInstalls?: number | null;
        FinalizedTickets?: number | null;
        TrustedOrganizations?: number | null;
        UniqueCustomers?: number | null;
    } | null;
};

export type SeaportsQueryVariables = Exact<{ [key: string]: never }>;

export type SeaportsQuery = {
    __typename?: 'Query';
    Seaports: Array<{
        __typename?: 'Seaports';
        Code: string;
        Title?: string | null;
        CountryName?: string | null;
    }>;
};

export type SearchResultReasonQueryVariables = Exact<{ [key: string]: never }>;

export type SearchResultReasonQuery = {
    __typename?: 'Query';
    SearchResultReason: Array<{
        __typename?: 'SearchResultReason';
        Description?: string | null;
        Title?: string | null;
        id: string;
    }>;
};

export type ShippingPricesQueryVariables = Exact<{
    FromCode: Scalars['String']['input'];
    ToCode: Scalars['String']['input'];
}>;

export type ShippingPricesQuery = {
    __typename?: 'Query';
    ShippingPrices: Array<{
        __typename?: 'ShippingPrices';
        id: string;
        RoundTrip?: boolean | null;
        DepartureDescription?: string | null;
        Class?: string | null;
        Price?: string | null;
    }>;
};

export type TicketingSectionsQueryVariables = Exact<{ [key: string]: never }>;

export type TicketingSectionsQuery = {
    __typename?: 'Query';
    TicketingSection: Array<{
        __typename?: 'TicketingSection';
        Title?: string | null;
        id: string;
        Icon?: string | null;
        Key?: string | null;
        Pin?: boolean | null;
        Sort?: number | null;
        Faqs?: Array<TicketingFaq> | null;
        Tutorials?: Array<{
            __typename?: 'TicketingSection_TicketingTutorials';
            id: string;
            TicketingTutorials_id?: {
                __typename?: 'TicketingTutorials';
                id: string;
                Title?: string | null;
                Tutorial?: string | null;
            } | null;
            TicketingSection_id?: {
                __typename?: 'TicketingSection';
                Key?: string | null;
            } | null;
        } | null> | null;
        Forms?: Array<{
            __typename?: 'TicketingForms';
            id: string;
            Title?: string | null;
            Form?: Array<TicketingForm> | null;
            Notes?: Array<TicketingFormNote> | null;
            Options?: Array<TicketingFormOption> | null;
            Key: string;
            WorkflowId?: string | null;
            ForOrganizationsOnly?: boolean | null;
            NeedBillCode?: boolean | null;
            PassengerFields?: Array<PassengerFieldsEnum> | null;
            GetPassengerMode: GetPassengerModeEnum;
            ForeignKey?: {
                __typename?: 'TicketingSection';
                Key?: string | null;
            } | null;
        } | null> | null;
    }>;
};

export type TripTermsQueryVariables = Exact<{
    DepartureTime: Scalars['String']['input'];
    Flight: Scalars['Boolean']['input'];
    Train: Scalars['Boolean']['input'];
    Bus: Scalars['Boolean']['input'];
    Carrier?: InputMaybe<Scalars['String']['input']>;
    International: Scalars['Boolean']['input'];
}>;

export type TripTermsQuery = {
    __typename?: 'Query';
    TripTerms: Array<{
        __typename?: 'TripTerms';
        id: string;
        Description?: string | null;
    }>;
};

export const OrganizationDetailDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'OrganizationDetail' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'CallNumber' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Description' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Name' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'OrganizationName' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Source' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                    defaultValue: {
                        kind: 'StringValue',
                        value: 'Site',
                        block: false,
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'GiftCardCount' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'Int' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'GiftCardCredit' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'GraphQLBigInt' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'create_OrganizationDetailNew_item',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'data' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'CallNumber',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'CallNumber',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Description',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Description',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Name',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Name',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'OrganizationName',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'OrganizationName',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Source',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Source',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'GiftCardCount',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GiftCardCount',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'GiftCardCredit',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GiftCardCredit',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    OrganizationDetailMutation,
    OrganizationDetailMutationVariables
>;
export const SearchResultSupportRequestDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SearchResultSupportRequest' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Description' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'FirstName' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'LastName' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Mobile' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Reason' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'create_SearchResultSupportRequests_item',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'data' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Description',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Description',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'FirstName',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'FirstName',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'LastName',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'LastName',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Mobile',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Mobile',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Reason',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Reason',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SearchResultSupportRequestMutation,
    SearchResultSupportRequestMutationVariables
>;
export const ShipReserveDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ShipReserve' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'AdultCount' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ChildCount' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'InfantCount' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'CarCount' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Origin' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Destination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'DepartureDate' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ReturnDate' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'FullName' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'PhoneNumber' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'create_ShipReserves_item',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'data' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'AdultCount',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AdultCount',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'ChildCount',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ChildCount',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'InfantCount',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'InfantCount',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'CarCount',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'CarCount',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Origin',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Origin',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Destination',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Destination',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'DepartureDate',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'DepartureDate',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'ReturnDate',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ReturnDate',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Fullname',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'FullName',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Phonenumber',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'PhoneNumber',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ShipReserveMutation, ShipReserveMutationVariables>;
export const ShipSearchLogDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ShipSearchLog' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'To' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'From' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'IsAvailable' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'create_ShipSearchLog_item',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'data' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'To' },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'To',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'From',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'From',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'IsAvailable',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'IsAvailable',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ShipSearchLogMutation,
    ShipSearchLogMutationVariables
>;
export const TaxiReserveDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'TaxiReserve' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'departureTime' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Date' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'mobileNumber' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'route' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'description' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'create_TaxiReserveRequests_item',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'data' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'departureTime',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'departureTime',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'mobileNumber',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobileNumber',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'name',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'route',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'route',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'description',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'description',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TaxiReserveMutation, TaxiReserveMutationVariables>;
export const ClubCategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ClubCategories' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ClubCategories' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Title' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Icon' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ClubCategoriesQuery, ClubCategoriesQueryVariables>;
export const ClubPrizesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ClubPrizes' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'UserType' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'UserLevel' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ClubPrizez' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'UserType',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_in',
                                                        },
                                                        value: {
                                                            kind: 'ListValue',
                                                            values: [
                                                                {
                                                                    kind: 'Variable',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'UserType',
                                                                    },
                                                                },
                                                                {
                                                                    kind: 'StringValue',
                                                                    value: 'All',
                                                                    block: false,
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'UserLevel',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_in',
                                                        },
                                                        value: {
                                                            kind: 'ListValue',
                                                            values: [
                                                                {
                                                                    kind: 'Variable',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'UserLevel',
                                                                    },
                                                                },
                                                                {
                                                                    kind: 'StringValue',
                                                                    value: 'All',
                                                                    block: false,
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'Description',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Link' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'date_created',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'BrandId' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Title',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Icon',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'filename_disk',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ExpireDate' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'HasDiscount',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'LinkTitle' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Score' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'ScoreDescription',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'UsedCount' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Category' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Title',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Icon',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ClubPrizesQuery, ClubPrizesQueryVariables>;
export const MagBestContentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MagBestContent' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'MagBestContent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Title' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Content' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'title',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Link' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MagBestContentQuery, MagBestContentQueryVariables>;
export const OrganizationStatisticsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'OrganizationStatistics' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'OrganizationStatistics' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'AppInstalls',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'FinalizedTickets',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'TrustedOrganizations',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'UniqueCustomers',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    OrganizationStatisticsQuery,
    OrganizationStatisticsQueryVariables
>;
export const SeaportsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Seaports' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Seaports' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Code' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Title' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'CountryName',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SeaportsQuery, SeaportsQueryVariables>;
export const SearchResultReasonDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'SearchResultReason' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'SearchResultReason' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'Description',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Title' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SearchResultReasonQuery,
    SearchResultReasonQueryVariables
>;
export const ShippingPricesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ShippingPrices' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'FromCode' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ToCode' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ShippingPrices' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'From',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'Code',
                                                        },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: '_eq',
                                                                    },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'FromCode',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'To' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'Code',
                                                        },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: '_eq',
                                                                    },
                                                                    value: {
                                                                        kind: 'Variable',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'ToCode',
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'RoundTrip' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'DepartureDescription',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Class' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Price' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ShippingPricesQuery, ShippingPricesQueryVariables>;
export const TicketingSectionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'TicketingSections' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'TicketingSection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sort' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'StringValue',
                                            value: 'Sort',
                                            block: false,
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Title' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Icon' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Key' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Pin' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Sort' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Faqs' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Tutorials' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'TicketingTutorials_id',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Title',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Tutorial',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'TicketingSection_id',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Key',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Forms' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Title',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Form',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Notes',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Options',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'Key',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'WorkflowId',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ForOrganizationsOnly',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'NeedBillCode',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'PassengerFields',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GetPassengerMode',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ForeignKey',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Key',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    TicketingSectionsQuery,
    TicketingSectionsQueryVariables
>;
export const TripTermsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'TripTerms' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'DepartureTime' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Flight' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Train' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Bus' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'Carrier' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'International' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'TripTerms' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filter' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Flight',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_eq',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Flight',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Train',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_eq',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Train',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Bus',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_eq',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'Bus',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'DepartureStartDate',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_lte',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'DepartureTime',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'DepartureEndDate',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_gte',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'DepartureTime',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'Carriers',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'TripTermsCarriers_id',
                                                        },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'Code',
                                                                    },
                                                                    value: {
                                                                        kind: 'ObjectValue',
                                                                        fields: [
                                                                            {
                                                                                kind: 'ObjectField',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: '_in',
                                                                                },
                                                                                value: {
                                                                                    kind: 'ListValue',
                                                                                    values: [
                                                                                        {
                                                                                            kind: 'Variable',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'Carrier',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'International',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: '_eq',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'International',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'Description',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TripTermsQuery, TripTermsQueryVariables>;
